require('../../modules/es.object.get-prototype-of');
var path = require('../../internals/path');

module.exports = path.Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/get-prototype-of.js
// module id = 4344
// module chunks = 25